var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0245A3",
    d: "M31.173 5.333H8.653L8.307 2.88A3.346 3.346 0 0 0 5 0H2.653v1.333H5c1 0 1.84.747 1.987 1.72l2.693 19.4a3.346 3.346 0 0 0 3.307 2.88H28V24H12.987c-1 0-1.84-.747-1.987-1.72L10.68 20h17.547L31.16 5.333zM10.507 18.667l-1.667-12h20.707l-2.4 12zm1.493 8a2.674 2.674 0 0 0-2.667 2.666C9.333 30.8 10.533 32 12 32s2.667-1.2 2.667-2.667-1.2-2.666-2.667-2.666m0 4c-.733 0-1.333-.6-1.333-1.334 0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333c0 .734-.6 1.334-1.333 1.334m12-4a2.674 2.674 0 0 0-2.667 2.666C21.333 30.8 22.533 32 24 32s2.667-1.2 2.667-2.667-1.2-2.666-2.667-2.666m0 4c-.733 0-1.333-.6-1.333-1.334 0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333c0 .734-.6 1.334-1.333 1.334M4.987 8H0V6.667h4.8zm.746 5.333H0V12h5.547zm.56 4 .187 1.334H0v-1.334h6.293"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgCart;